import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import DashboardContent from './DashboardContent';
import ReferralTools from './ReferralTools';
import Earnings from './Earnings';
import '../styles/Dashboard.css';

const Dashboard = ({ user, onLogout }) => {
  const [activeSection, setActiveSection] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Close sidebar when window is resized to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleRequestPayout = () => {
    setActiveSection('earnings');
  };

  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return <DashboardContent onRequestPayout={handleRequestPayout} />;
      case 'referral':
        return <ReferralTools />;
      case 'earnings':
        return <Earnings />;
      default:
        return <DashboardContent onRequestPayout={handleRequestPayout} />;
    }
  };

  const getPageTitle = () => {
    switch (activeSection) {
      case 'dashboard':
        return 'Affiliate Dashboard';
      case 'referral':
        return 'Referral Tools';
      case 'earnings':
        return 'Request Payout';
      default:
        return 'Affiliate Dashboard';
    }
  };

  const getBreadcrumb = () => {
    switch (activeSection) {
      case 'dashboard':
        return 'Portal > Dashboard > Overview';
      case 'referral':
        return 'Portal > Referral Tools > QR Code';
      case 'earnings':
        return 'Portal > Earnings > Request Payout';
      default:
        return 'Portal > Dashboard > Overview';
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar 
        activeSection={activeSection} 
        onSectionChange={setActiveSection}
        isOpen={sidebarOpen}
        onToggle={handleMenuToggle}
        user={user}
      />
      
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <Topbar 
          user={user} 
          onLogout={onLogout} 
          pageTitle={getPageTitle()}
          breadcrumb={getBreadcrumb()}
          onMenuToggle={handleMenuToggle}
        />
        {renderContent()}
      </div>
    </div>
  );
};

export default Dashboard;